import { render } from "./TrainingInfosComponent.vue?vue&type=template&id=b9611900&scoped=true"
import script from "./TrainingInfosComponent.vue?vue&type=script&lang=js"
export * from "./TrainingInfosComponent.vue?vue&type=script&lang=js"

import "./TrainingInfosComponent.vue?vue&type=style&index=0&id=b9611900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9611900"]])

export default __exports__